import { datadogRum } from '@datadog/browser-rum'

const init = function () {
  datadogRum.init({
    applicationId: '60efb441-ec50-4159-8448-70c7c03537c7',
    clientToken: 'pubcc016d49458b2e60c6d156ab8d9b5a32',
    site: 'datadoghq.com',
    service: 'dashboard',
    env: window.location.host,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [(url) => url.startsWith('https://dashboard.y.uno')],
  })
}

if (window.location.host === 'dashboard.y.uno') {
  init()
  datadogRum.startSessionReplayRecording()
}

export { datadogRum }
